<template>
  <div class="ing-container" :class="{ active: expanded || replacing }">
    <div class="ingredient-name">
      <div v-if="!replacing" class="ingredient-name-with-allergens">
        <Tooltip :disabled="!editable" placement="top">
          <template #trigger>
            <div
              class="ingredient-name-button"
              :class="{ disabled: !editable, expanded }"
              @click.stop="editable && emit('replaceStart')"
            >
              {{ ingredient.name }}
            </div>
          </template>
          Kliknij, aby zamienić składnik w całym jadłospisie
        </Tooltip>
        <div v-for="flag in visibleFlags" :key="flag" :class="['allergens', flag]" />
      </div>
      <DishOrIngredientAddInput
        v-else
        test-id="DietDetailShoppingList"
        class="add-ingredient-input"
        mode="ingredient"
        :filters="filters"
        @select="emit('replace', ingredient.id, $event.dishOrIngredientId)"
        @keyup.esc="emit('replaceEnd')"
        @close="emit('replaceEnd')"
      />
    </div>
    <div class="ingredient-quantity">{{ ingredient.quantity }}</div>
    <div class="ingredient-measurement">
      {{ ingredient.measurementQuantity }}
      x {{ ingredient.measurement }}
    </div>
    <div class="ingredient-actions">
      <Tooltip placement="top">
        <template #trigger>
          <BaseIcon
            class="icon expander"
            size="18"
            :name="expanded ? 'expand_less' : 'expand_more'"
            @click="emit('toggle')"
          />
        </template>
        {{ expanded ? 'Zwiń informacje o potrawach' : 'Rozwiń informacje o potrawach i dniach' }}
      </Tooltip>
    </div>
  </div>
  <ShoppingListIngredientSources
    v-if="expanded"
    :day-short="dayShort"
    :sources="sources"
    @day="emit('day', $event)"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  import BaseIcon from '@/components/BaseIcon.vue'
  import DishOrIngredientAddInput from '@/components/DishOrIngredientAddInput.vue'
  import { Tooltip } from '@/components/ui'

  import type { Coordinates, StoreDiet } from '@/types/Diet'

  import type { ShoppingListIngredient, ShoppingListSource } from '../../types'
  import ShoppingListIngredientSources from '../ShoppingListIngredientSources/ShoppingListIngredientSources.vue'

  const props = defineProps<{
    allergensEnabled: boolean
    dayShort: (index: number) => string
    editable: boolean
    expanded: boolean
    filters?: StoreDiet['data']['dish_search_filters']
    ingredient: ShoppingListIngredient
    replacing: boolean
    sources: ShoppingListSource[]
  }>()
  const emit = defineEmits<{
    day: [coordinates: Coordinates]
    replace: [oldId: number, newId: number]
    replaceEnd: []
    replaceStart: []
    toggle: []
  }>()
  const visibleFlags = computed(() =>
    [
      props.ingredient.notLike && 'not-like',
      props.ingredient.like && 'like',
      props.ingredient.allergies && 'allergies',
      props.ingredient.intolerances && 'intolerances',
    ].filter((flag): flag is string => props.allergensEnabled && Boolean(flag)),
  )
</script>
